import { useContext } from 'react';
import { AuthContext } from '../store/auth.provider';
import { useNavigate } from 'react-router-dom';

export const usePermissions = () => {
    const { user } = useContext<any>(AuthContext);
    let history = useNavigate();

    const permissions = (user?.roles || [])
        .flatMap((role) => role?.permissions || [])
        .map((permission) => permission?.key)
        .filter(Boolean);

    const checkPermission = (permission) => {
        return permissions.includes(permission);
    }

    const checkLevel = (level) => {
        return Number(user?.level) === level;
    }

    const isAdminOrManager = () => {
        return user?.roles?.some((role) => !role.is_client || role.name === "Client_Gerant");
    }

    // const checkRole = (role) => {
    //     return user?.role?.name === role;
    // }

    const isRevertoEmployee = () => {
        return user?.enterprise?.name === "REVERTO";
    }

    const checkRevertoOrHome = () => {
        if(!isRevertoEmployee()){
            history("/");
        }
    }

    return {
        user,
        isAdminOrManager,
        checkPermission,
        checkLevel,
        isRevertoEmployee,
        checkRevertoOrHome
    };
}
